import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import TrustSection from "../components/TrustSection";
import Materials from "../components/Materials";
import EvaluationForm from "../components/EvaluationForm";
import Gallery from "../components/Gallery";
import Testimonials from "../components/Testimonials";
import LocationSection from "../components/LocationSection";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";
import { Toaster } from "../components/ui/sonner";

export default function Home() {
  return (
    <div className="bg-[var(--rc-bg)] min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <TrustSection />
        <Materials />
        <EvaluationForm />
        <Gallery />
        <Testimonials />
        <LocationSection />
        <FAQ />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#141415",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}
